import { createStyles } from "antd-style";

const useDateTimeScreenStyles = createStyles(({ css, prefixCls }) => {
  return {
    screen: css`
      height: 100%;
    `,
    stepWrapper: css`
      padding: 12px 32px;
      border-radius: var(--Global-token-Radius-radiusLG, 16px);
      background: var(--Global-token-Bg-colorBgBase, #fff);
    `,
    stepIconWrapper: css`
      .${prefixCls}-steps-item-title {
        text-align: center;
        font-feature-settings: "liga" off, "clig" off;
        color: var(--Global-token-Text-colorTextDescription, rgba(0, 0, 0, 0.45));
        /* MD/Footnote/Regular */
        line-height: 100%;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        text-align: center;
        white-space: pre-wrap;
        inline-size: 72px;
      }
      .${prefixCls}-steps-item-content {
        margin-top: 8px;
      }

      .${prefixCls}-steps-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        padding: 6px;
        border-radius: var(--Global-token-Radius-radiusXL, 24px);
        background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
        color: var(--Global-token-Icon-colorIconPrimary, #8c8c8c);
        transition: all 0.2s ease-in-out;
      }

      .${prefixCls}-steps-item-tail {
        transition: all 0.2s ease-in-out;
      }

      &.${prefixCls}-steps-item-process {
        .${prefixCls}-steps-icon {
          color: white;
          background: var(--Global-token-Primary-colorPrimary, #1677ff);
        }
        .${prefixCls}-steps-item-title {
          color: var(--Global-token-Primary-colorPrimaryText, #1677ff);
        }
      }

      &.${prefixCls}-steps-item-finish {
        .${prefixCls}-steps-icon {
          color: white;
          background: var(--Global-token-Success-colorSuccess, #52c41a);
        }
      }
    `,
  };
});
export default useDateTimeScreenStyles;
